import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Icon from "../Icon";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var Link = /*#__PURE__*/function (_Component) {
  _inherits(Link, _Component);
  var _super = _createSuper(Link);
  function Link() {
    var _this;
    _classCallCheck(this, Link);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      if (!_this.props.href) {
        event.preventDefault();
      } else if (event.metaKey || event.shiftKey || event.altKey || event.ctrlKey) {
        return;
      }
      _this.props.onClick(event);
    });
    return _this;
  }
  _createClass(Link, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        href = _this$props.href,
        target = _this$props.target,
        onClick = _this$props.onClick,
        hideIcon = _this$props.hideIcon,
        notPseudo = _this$props.notPseudo,
        className = _this$props.className;
      var classNameModifiers = {
        link: true,
        pseudoLink: !href && !notPseudo
      };
      if (!href) {
        classNameModifiers.hideVisitedColor = true;
      }
      var icon = href && target === '_blank' && !hideIcon ? /*#__PURE__*/React.createElement(Icon, {
        className: cx('icon'),
        name: "externalLink"
      }) : null;
      return /*#__PURE__*/React.createElement("a", {
        className: cx(className, classNameModifiers),
        "data-component": "Link",
        href: href || '#',
        onClick: onClick ? this.onClick : undefined,
        rel: href && target === '_blank' ? 'noopener' : null,
        role: href ? undefined : 'button',
        target: href ? target : null
      }, /*#__PURE__*/React.createElement("span", {
        className: cx('text')
      }, children), icon);
    }
  }]);
  return Link;
}(Component);
export { Link as default };
Link.defaultProps = {
  children: 'Перейти'
};
Link.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.any,
  href: PropTypes.string,
  target: PropTypes.oneOf(['_self', '_blank', '_parent', '_top']),
  onClick: PropTypes.func,
  notPseudo: PropTypes.bool,
  hideIcon: PropTypes.bool
} : {};